import { MagicConfigMixin, debounce, RoutablePage, deviceChange, isBreakpointLargeSync, configQuery } from '@gig/magic-common';
import { Mixins, Prop, Emit, Watch, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let LoyaltyProgressComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.percentageLoyalty = 0;
    this.userLevel = 0;
    this.isComplete = false;
    this.isLarge = false;
    this.showRewardsButton = false;
    this.debouncedLoyaltyPointsUpdate = debounce(this.handleLoyaltyPointsUpdate, 300);
  }
  goToRewards() {
    this.isComplete = false;
    this.routeTo({
      route: RoutablePage.REWARDS
    });
  }
  created() {
    return __async(this, null, function* () {
      var _a;
      this.deviceSubscription = deviceChange(() => {
        this.isLarge = isBreakpointLargeSync();
      });
      this.showRewardsButton = (_a = yield configQuery(`showProgressBarRewardButton`)) != null ? _a : false;
      this.fetchProgress();
      this.unsubLoyalty = magic.events.loyaltyPointsUpdate((data) => this.debouncedLoyaltyPointsUpdate(data)).unsub;
    });
  }
  handleLoyaltyPointsUpdate(data) {
    if (this.userLevel < data.level) {
      this.isComplete = true;
      this.userLevel = data.level;
    } else {
      this.isComplete = false;
    }
    this.percentageLoyalty = data.progress;
  }
  destroyed() {
    var _a;
    if (this.unsubLoyalty) {
      this.unsubLoyalty();
    }
    (_a = this.deviceSubscription) == null ? void 0 : _a.unsubscribe();
  }
  fetchProgress() {
    return __async(this, null, function* () {
      const user = magic.session.getUser();
      if (!user) {
        return;
      }
      const { userId } = user;
      const loyaltyPromise = magic.invokeCached(60, magic.methods.loyalty, "userProgress")({
        userId
      });
      const { progress, level } = yield loyaltyPromise;
      this.percentageLoyalty = progress;
      this.userLevel = level;
    });
  }
  get roundedProgress() {
    return this.isComplete ? 100 : Math.floor(this.percentageLoyalty);
  }
  get levelTranslation() {
    return this.isComplete ? "progress-bar.levelUp-text" : "progress-bar.level-text";
  }
  userLevelUpdated() {
    return this.userLevel;
  }
  infoClick() {
    return;
  }
};
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "topNavVariant", 2);
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "shouldShowInfo", 2);
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "showProgressBarOnly", 2);
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "showLevelOnTop", 2);
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "displayRewardsButton", 2);
__decorateClass([
  Prop(Boolean)
], LoyaltyProgressComponent.prototype, "wrapperWidth", 2);
__decorateClass([
  Emit("toggle-menu")
], LoyaltyProgressComponent.prototype, "goToRewards", 1);
__decorateClass([
  Watch("userLevel"),
  Emit("userLevelUpdated")
], LoyaltyProgressComponent.prototype, "userLevelUpdated", 1);
__decorateClass([
  Emit("info")
], LoyaltyProgressComponent.prototype, "infoClick", 1);
LoyaltyProgressComponent = __decorateClass([
  Component({
    name: "loyalty-progress"
  })
], LoyaltyProgressComponent);

export default LoyaltyProgressComponent;
